<template>
  <v-navigation-drawer
    v-model="formShow"
    clipped
    right
    fixed
    width="30rem"
    style="top: 100px"
    stateless
  >
    <v-form
      ref="form"
      lazy-validation
      class="d-flex flex-column"
      style="height: calc(100% - 100px)"
    >
      <v-toolbar flat dark color="primary">
        <v-list-item class="px-0" v-if="formAction === 'add'">
          <v-list-item-icon>
            <v-icon>mdi-plus</v-icon>
          </v-list-item-icon>
          <v-list-item-title>เพิ่มกลุ่มสิทธิใหม่</v-list-item-title>
        </v-list-item>
        <v-list-item class="px-0" two-line v-else>
          <v-list-item-content>
            <v-list-item-title>
              {{ taRightGroupInit.title_th }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ taRightGroupInit.title_en }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-spacer></v-spacer>

        <v-btn icon @click="onClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <div class="pa-5" style="height: 100%; overflow: auto">
        <div>
          <label class="body-2">
            คำอธิบาย (ไทย)
            <span class="red--text"><strong>*</strong></span>
          </label>
          <v-text-field
            class="fix-google-chrome mt-1"
            v-model="taRightGroup.title_th"
            :rules="[(v) => !!v || 'โปรดระบุคำอธิบาย']"
            outlined
            dense
            required
            clearable
            @change="checkEmpty($event, 'title_th')"
          >
          </v-text-field>
        </div>
        <div>
          <label class="body-2"> คำอธิบาย (อังกฤษ) </label>
          <v-text-field
            class="fix-google-chrome mt-1"
            v-model="taRightGroup.title_en"
            outlined
            dense
            clearable
            @change="checkEmpty($event, 'title_en')"
          >
          </v-text-field>
        </div>
        <div>
          <label class="body-2">
            กลุ่ม Device
            <span class="red--text"><strong>*</strong></span>
          </label>
          <v-autocomplete
            class="fix-google-chrome mt-1"
            v-model="taRightGroup.hardware_group_uuid"
            :rules="[(v) => !!v || 'โปรดระบุกลุ่ม Device']"
            :items="taHardwaresGroup"
            item-text="title_th"
            item-value="hardware_group_uuid"
            outlined
            dense
          >
          </v-autocomplete>
        </div>
        <div>
          <label class="body-2">
            กลุ่มพนักงาน
            <span class="red--text"><strong>*</strong></span>
          </label>
          <v-autocomplete
            class="fix-google-chrome mt-1"
            v-model="taRightGroup.employee_group_uuid"
            :rules="[(v) => !!v || 'โปรดระบุกลุ่ม พนักงาน']"
            :items="taEmployeesGroup"
            item-text="title_th"
            item-value="employee_group_uuid"
            outlined
            dense
          >
          </v-autocomplete>
        </div>
      </div>
      <v-toolbar flat color="blue-grey lighten-4">
        <v-row
          justify="center"
          align="center"
          v-if="!isTaRightGroupDataChange && formAction === 'edit'"
        >
          <v-btn icon @click="onDelete">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-row>
        <v-row justify="center" align="center" v-else>
          <v-btn
            class="primary mr-3"
            depressed
            v-if="formAction === 'add'"
            @click="onSubmit"
            >ตกลง
          </v-btn>
          <v-btn class="primary mr-3" depressed v-else @click="onSave"
            >บันทึก
          </v-btn>
          <v-btn depressed @click="onReset">ยกเลิก</v-btn>
        </v-row>
      </v-toolbar>
    </v-form>
    <ConfirmDialog
      :dialog="confirmDialogDelete"
      :loading="confirmDialogDeleteLoading"
      :dialogData="confirmDialogDeleteData"
      @cancelConfirmDialog="cancelConfirmDialogDelete"
      @submitConfirmDialog="submitConfirmDialogDelete"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
  </v-navigation-drawer>
</template>

<script>
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'

export default {
  components: {
    ConfirmDialog,
  },
  props: {
    formShow: {
      type: Boolean,
      default: false,
    },
    formAction: {
      type: String,
      default: '',
    },
    taRightGroup: {
      type: Object,
    },
    taRightGroupInit: {
      type: Object,
    },
  },
  data() {
    return {
      confirmDialogDelete: false,
      confirmDialogDeleteLoading: false,
      confirmDialogDeleteData: {},
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
    }
  },
  computed: {
    isTaRightGroupDataChange() {
      if (
        this.taRightGroup?.hardware_group_uuid !==
          this.taRightGroupInit?.hardware_group_uuid ||
        this.taRightGroup?.employee_group_uuid !==
          this.taRightGroupInit?.employee_group_uuid ||
        this.taRightGroup.title_th !== this.taRightGroupInit.title_th ||
        this.taRightGroup.title_en !== this.taRightGroupInit.title_en
      ) {
        this.$emit('isTaRightGroupDataChange', true)
        return true
      }
      this.$emit('isTaRightGroupDataChange', false)
      return false
    },
    taHardwaresGroup() {
      return this.$store.state.taHardwaresGroup.taHardwaresGroup
    },
    taEmployeesGroup() {
      return this.$store.state.taEmployeesGroup.taEmployeesGroup
    },
  },
  methods: {
    ...mapActions({
      addTaRightGroup: 'taRightsGroup/addTaRightGroup',
      editTaRightGroup: 'taRightsGroup/editTaRightGroup',
      deleteTaRightGroup: 'taRightsGroup/deleteTaRightGroup',
    }),
    checkEmpty(value, field) {
      if (value) {
        this.taRightGroup[field] = value.trim()
      }
    },
    onDelete() {
      this.confirmDialogDelete = true
      this.confirmDialogDeleteData = {
        title: 'ยืนยันการลบ',
        text: 'คุณต้องการลบกลุ่มสิทธิ์',
        value: this.taRightGroup.title_th,
        item: this.taRightGroup,
      }
    },
    cancelConfirmDialogDelete() {
      this.confirmDialogDelete = false
    },
    submitConfirmDialogDelete({ authority_uuid }) {
      this.confirmDialogDeleteLoading = true

      const { company_uuid } = this.$store.state.authentication.company

      const payload = {
        company_uuid,
        authority_uuid,
      }

      this.deleteTaRightGroup(payload)
        .then(() => {
          this.confirmDialogDeleteLoading = false
          this.confirmDialogDelete = false

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'ลบข้อมูลสำเร็จ',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)

          this.$emit('formActionCompleted', this.formAction)
          this.$refs.form.reset()
        })
        .catch((error) => {
          this.confirmDialogDeleteLoading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    onSubmit() {
      if (this.$refs.form.validate()) {
        this.$store.state.loading = true

        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          company_uuid,
          body: {
            hardware_group_uuid: this.taRightGroup.hardware_group_uuid,
            employee_group_uuid: this.taRightGroup.employee_group_uuid,
            timezone_uuid: this.taRightGroup.timezone_uuid,
            title_th: this.taRightGroup.title_th,
            title_en: this.taRightGroup.title_en || null,
          },
        }

        this.addTaRightGroup(payload)
          .then(() => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'success',
              timeout: 2000,
              message: 'เพิ่มข้อมูลสำเร็จ',
            }

            this.$store.commit('SET_SNACKBAR', snackbar)

            this.$emit('formActionCompleted', this.formAction)
            this.$refs.form.reset()
          })
          .catch((error) => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
          })
      }
    },
    onSave() {
      if (this.$refs.form.validate()) {
        this.$store.state.loading = true

        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          company_uuid,
          authority_uuid: this.taRightGroup.authority_uuid,
          body: {
            hardware_group_uuid: this.taRightGroup.hardware_group_uuid,
            employee_group_uuid: this.taRightGroup.employee_group_uuid,
            timezone_uuid: this.taRightGroup.timezone_uuid,
            title_th: this.taRightGroup.title_th,
            title_en: this.taRightGroup.title_en || null,
          },
        }

        this.editTaRightGroup(payload)
          .then(() => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'success',
              timeout: 2000,
              message: 'แก้ไขข้อมูลสำเร็จ',
            }

            this.$store.commit('SET_SNACKBAR', snackbar)

            this.$emit('formActionCompleted', this.formAction)
            this.$refs.form.reset()
          })
          .catch((error) => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
          })
      }
    },
    onClose() {
      if (this.isTaRightGroupDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
        }
        this.confirmDialogDataChange = true
      } else {
        this.$emit('formActionCompleted', this.formAction)
        this.$refs.form.reset()
      }
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange() {
      this.confirmDialogDataChange = false

      this.$emit('formActionCompleted', this.formAction)
      this.$refs.form.reset()
    },
    onReset() {
      if (this.formAction === 'add' || this.formAction === '') {
        this.$refs.form.reset()
      } else {
        this.$emit('onReset', this.formAction)
      }
    },
  },
}
</script>
